import { Component, ElementRef, Renderer2 } from '@angular/core';
import { SafeHtml } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { Subscription, catchError, forkJoin, map, of, tap } from 'rxjs';
import { DecoratedVariation } from 'src/app/models/DecoratedVariation';
import { JsonApiResponse } from 'src/app/models/jsonapi';
import { AuthService } from 'src/app/services/auth.service';
import { FooldalService } from 'src/app/services/fooldal.service';
import { HtmlconvertService } from 'src/app/services/htmlconvert.service';
import { SharedService } from 'src/app/services/shared.service';


@Component({
  selector: 'app-elofizetes',
  templateUrl: './elofizetes.component.html',
  styleUrls: ['./elofizetes.component.css']
})
export class ElofizetesComponent {
  courseDetails: any[] = []; //feliratkozott
  courseDetailsExpires: any[] = [];
  courseNonEnrollmentDetails: any[] = [];//nem feliratkozott
  courseNonEnrollmentsDetailsExpires: any[] = [];
  vidCourseNonEnrollmentsDetailsExpires: any[] = [];
  courseNonEnrollmentsDetailsExpiresProm: any[] = [];
  vidCourseNonEnrollmentsDetailsExpiresProm: any[] = [];
  hasProm: boolean = false;
  promRole: any[] = [];
  course: any[] = [];
  courseCommercie: any[] = [];
  products: any[] = [];
  private loggedInUserSubscription?: Subscription;
  loggedUser: any;
  percentage: number = 0;
  promotionObject: any = {};
  promotionsArray: any[] = [];
  postDataProducts: any = {};
  active: boolean = false;
  productDatas: any = {};
  cuoponDatas: any = {};
  licensProduct: any[] = [];
  productsForLicens: any[] = [];
  productsVidForLicens: any[] = [];

  items: any[] = [];
  activeItems: any[] = [];

  showModal: boolean = false;
  modalTitle: string = '';
  modalContent: string = '';
  platform: string = '';
  modalActionTitle: string = '';
  modalCancelTitle: string = '';
  modalData: any;

  public cuoponIdProduct: string = "";

  coursePreviews: any[] = [];

  constructor(private fooldalService: FooldalService, private sharedService: SharedService,
    private htmlconvertService: HtmlconvertService, private authService: AuthService,
    private router: Router, private renderer: Renderer2) {
      this.sharedService.spinner$.next(true);
  }

  addCart(type: any, id: any) {
    if(!localStorage.getItem('login')) {
      this.router.navigate(['/signin'], { queryParams: { from: 'elofizetes' } });
    }
    this.postDataProducts = {
      data: [
        {
          type: type,
          id: id,
          meta: {
            quantity: 1,
            combine: true,
          },
        },
      ],
    };
    const objProf = {
      name: '',
    };
    const objBilling = {
      country_code: '',
      locality: '',
      postal_code: '',
      address_line1: '',
      address_line2: '',
      given_name: '',
      family_name: '',
    };
    this.fooldalService.addItemToCart(this.postDataProducts).subscribe((p:any) => {
      const value = p.data[0];
            const obj = {
              title: '',
              price: '',
            };
            obj.title = value.attributes.title;
            obj.price = value.attributes.total_price.formatted;
            localStorage.setItem('product', JSON.stringify(obj));

            this.authService.getCurrentUser().subscribe((user) => {
              const vv = user.data[0];
                    objProf.name = vv.attributes.name;

                    if (localStorage.getItem('login')) {
                      var loginData = JSON.parse(localStorage.getItem('login') || '');

                      if (loginData && loginData.current_user && loginData.current_user.name) {
                        var name = loginData.current_user.name;
                      }
                    }

                    if (name === objProf.name) {
                      var userId = vv.id;
                      this.fooldalService.getProfileCustomer().subscribe((profile: any) => {
                        const v = profile.data[0];
                        objBilling.country_code = v.attributes.address.country_code;
                        objBilling.locality = v.attributes.address.locality;
                        objBilling.postal_code = v.attributes.address.postal_code;
                        objBilling.address_line1 = v.attributes.address.address_line1;
                        objBilling.address_line2 = v.attributes.address.address_line2;
                        objBilling.given_name = v.attributes.address.given_name;
                        objBilling.family_name = v.attributes.address.family_name;
                        this.productDatas = {
                          "data": {
                            "type": value.relationships.order_id.data.type,
                            "id": value.relationships.order_id.data.id,
                            "attributes": {
                              "billing_information": {
                                "address": {
                                  "country_code": objBilling.country_code,
                                  "locality": objBilling.locality,
                                  "postal_code": objBilling.postal_code,
                                  "address_line1": objBilling.address_line1,
                                  "address_line2": objBilling.address_line2,
                                  "given_name": objBilling.given_name,
                                  "family_name": objBilling.family_name,
                                },
                                "tax_number": {
                                  "type": null,
                                  "value": null
                                }
                              }
                            },
                            "relationships": {
                              "uid": {
                                "data": {
                                  "type": "user--user",
                                  "id": userId
                                }
                              }
                            }
                          }
                        };
                        var orderId = value.relationships.order_id.data.id;
                        this.fooldalService.addProductWithCart(this.productDatas, orderId).subscribe((p) => {
                          for (const [keyP, valueP] of Object.entries(p)) {
                            if (keyP === 'data') {
                              for (let k in valueP) {
                                localStorage.setItem('productId', valueP.id.toString());
                              }
                            }
                          }
                          if (localStorage.getItem('login')) {
                            this.router.navigate(['/fizetes']);
                          } else {
                            this.router.navigate(['/signin'], { queryParams: { from: 'elofizetes' } });
                          }
                        });
                      });
                    } else {
                      var userId2 = localStorage.getItem('user_id');
                      if (userId2 !== null) {
                        var userIdIfNotLog = userId2.replace(/"/g, '');
                      } else {
                      }
                      this.fooldalService.getProfileCustomer().subscribe((profile) => {
                        for (const [k, v] of Object.entries(profile)) {
                          if (k === 'data') {
                            for (let j in v) {
                              if (userIdIfNotLog === v[j].relationships.uid.data.id) {
                                objBilling.country_code = v[j].attributes.address.country_code;
                                objBilling.locality = v[j].attributes.address.locality;
                                objBilling.postal_code = v[j].attributes.address.postal_code;
                                objBilling.address_line1 = v[j].attributes.address.address_line1;
                                objBilling.address_line2 = v[j].attributes.address.address_line2;
                                objBilling.given_name = v[j].attributes.address.given_name;
                                objBilling.family_name = v[j].attributes.address.family_name;
                              }
                            }
                          }
                        }
                        this.productDatas = {
                          "data": {
                            "type": value.relationships.order_id.data.type,
                            "id": value.relationships.order_id.data.id,
                            "attributes": {
                              "billing_information": {
                                "address": {
                                  "country_code": objBilling.country_code,
                                  "locality": objBilling.locality,
                                  "postal_code": objBilling.postal_code,
                                  "address_line1": objBilling.address_line1,
                                  "address_line2": objBilling.address_line2,
                                  "given_name": objBilling.given_name,
                                  "family_name": objBilling.family_name,
                                },
                                "tax_number": {
                                  "type": null,
                                  "value": null
                                }
                              }
                            },
                            "relationships": {
                              "uid": {
                                "data": {
                                  "type": "user--user",
                                  "id": userIdIfNotLog
                                }
                              }
                            }
                          }
                        };
                        var orderId = value.relationships.order_id.data.id;
                        this.fooldalService.addProductWithCart(this.productDatas, orderId).subscribe((p) => {
                          for (const [keyP, valueP] of Object.entries(p)) {
                            if (keyP === 'data') {
                              for (let k in valueP) {
                                localStorage.setItem('productId', valueP.id.toString());
                              }
                            }
                          }
                        });
                        if (localStorage.getItem('login')) {
                          this.router.navigate(['/fizetes']);
                        } else {
                          this.router.navigate(['/signin'], { queryParams: { from: 'elofizetes' } });
                        }
                      });
                    }
            });

    });
  }

  isCourseActive(sku: string): boolean {
    return this.licensProduct.some(item => item.sku === sku);
  }

  cancel(licenseUuid: string) {
    forkJoin([this.fooldalService.cancelSubscription(licenseUuid), this.fooldalService.cancelLicense(licenseUuid)]).subscribe(() => {
      window.location.reload();
    });
  }

  // ngOnInit() {
  //   this.sharedService.spinner$.next(true);

  //   forkJoin({
  //     variations: this.fooldalService.getAllSortedVariations(),
  //     licenses: this.loggedUser
  //       ? this.fooldalService.allLicensesOfCurrentUser()
  //       : of<JsonApiResponse>({ data: [] }),
  //   }).subscribe(({ variations, licenses }) => {
  //     this.items = variations.map(v =>
  //       this.decorateVariation(v, licenses.data)
  //     );

  //     this.sharedService.spinner$.next(false);
  //   });

  // }

  // private decorateVariation(variation: any, licenses: any[]) {
  //   console.log(variation);
  //   const product = variation.product_id?.data;

  //   const license = licenses.find(
  //     l => l.product_variation?.id === variation.id
  //   );

  //   return {
  //     id: variation.id,
  //     title: variation.field_variation_name,
  //     desc: this.htmlconvertService.convertToHtml(
  //       variation.field_variation_description?.processed
  //     ),
  //     price: variation.price?.formatted,
  //     weight: variation.field_weight ?? 0,

  //     hasActiveLicense: license?.state === 'active',
  //     excluded: false, // your logic
  //     type: product?.type,
  //   };
  // }

  // private decorateVariation(
  //   variation: any,
  //   licenses: any[],
  //   options?: {
  //     isSecondary?: boolean;
  //     isVideoStore?: boolean;
  //     excluded?: boolean;
  //   }
  // ): DecoratedVariation | null {
  //   if (!variation.status) {
  //     return null;
  //   }

  //   // skip free videostore
  //   if (
  //     options?.isVideoStore &&
  //     (variation.sku === 'VTFREE' ||
  //       variation.sku === 'VTFREEF' ||
  //       variation.price?.number == 0)
  //   ) {
  //     return null;
  //   }

  //   const license = licenses.find(
  //     l => l.product_variation?.id === variation.id
  //   );

  //   const { title, month } = this.parseTitleAndMonth(variation);

  //   let price = variation.price?.formatted;

  //   // videostore discount logic
  //   if (options?.isVideoStore && this.percentage) {
  //     const base = Number(variation.price.number);
  //     const discounted = base - base * this.percentage;
  //     price =
  //       discounted
  //         .toFixed(0)
  //         .replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ' Ft';
  //   }

  //   return {
  //     id: variation.id,
  //     type: variation.type,
  //     sku: variation.sku,
  //     title,
  //     month,
  //     desc: this.htmlconvertService.convertToHtml(
  //       variation.field_variation_description?.processed
  //     ),
  //     price,
  //     list_price: variation.list_price?.formatted,
  //     weight: variation.field_weight ?? 0,

  //     isVideoStore: !!options?.isVideoStore,
  //     isSecondary: !!options?.isSecondary,
  //     alreadyHasLicense: license?.state === 'active',
  //     excluded: options?.excluded,
  //   };
  // }

  ngOnInit() {
    this.sharedService.spinner$.next(true);

    localStorage.removeItem('teremben');
    this.loggedUser = this.authService.isAuthenticated();

    // előnézetek
    this.fooldalService.getPreviews().subscribe((previewResponse:any) => {
      previewResponse.data.forEach((preview: any) => {
        const variations = preview.variations.map((variation: any) => {
          return {
            link: preview.title,
            title: variation.field_variation_name,
            desc: this.htmlconvertService.convertToHtml(variation.field_variation_description?.processed),
            price: variation.price.formatted,
          }
        });
        this.coursePreviews.push(...variations);
      });
    });


    // előfizethető kurzusok
    forkJoin({
      variations: this.fooldalService.getAllSortedVariations(),
      licenses: this.loggedUser
        ? this.fooldalService.allLicensesOfCurrentUser()
        : of({ data: [] }),
    }).subscribe(({ variations, licenses }) => {
        const lic = licenses.data ?? [];

        const ownedCourseIds = lic
          .map(l => l.product_variation?.product_id?.field_course?.id)
          .filter(Boolean);

        const excludedCourseIds = lic.flatMap(l =>
          l.state === 'active' &&
          Array.isArray(l.product_variation?.product_id?.field_excludes_courses)
            ? l.product_variation.product_id.field_excludes_courses.map((ex: any) => ex.id)
            : []
        );

        const decorated = variations
          .map(v =>
            this.decorateVariation(v, {
              licenses: lic,
              ownedCourseIds,
              excludedCourseIds
            })
          )
          .filter(Boolean)
          .sort((a, b) => (a.weight ?? 0) - (b.weight ?? 0));

        // RUN ASYNC CHECKS
        const asyncChecks = decorated
          .filter(v => v.needsPrerequisiteCheck)
          .map(v =>
            this.fooldalService
              .enrolledUserOutline(v.prerequisiteId)
              .pipe(
                map((res: any) => ({
                  id: v.id,
                  completed: res?.data?.attributes?.completed === true
                })),
                catchError(() =>
                  of({ id: v.id, completed: false })
                )
              )
          );

          if (asyncChecks.length) {

            forkJoin(asyncChecks).subscribe(results => {
              const completedIds = results
                .filter(r => r.completed)
                .map(r => r.id);

              const final = decorated.filter(v =>
                !v.needsPrerequisiteCheck || completedIds.includes(v.id)
              );

              this.items = final.filter(v => !v.free);
              this.activeItems = final.filter(v => v.alreadyHasLicense);
              this.sharedService.spinner$.next(false);
            });
          } else {
            this.items = decorated.filter( v => !v.free);
            this.activeItems = decorated.filter(i => i.alreadyHasLicense);
            this.sharedService.spinner$.next(false);
          }
    });

  }

  private decorateVariation(
    v: any,
    ctx: {
      licenses: any[];
      ownedCourseIds: string[];
      excludedCourseIds: string[];
    }
  ) {
    if (!v.status) {
      return null;
    }

    const license = ctx.licenses.find(l => l.product_variation?.id === v.id && l.state == 'active');

    const licenseByRole = ctx.licenses.find(l => 
      l?.license_type === 'role' && l.state == 'active' && v?.license_type?.target_plugin_id === 'role'
      && l?.license_role?.meta?.drupal_internal__target_id == v?.license_type?.target_plugin_configuration?.license_role
    );
    const hasActiveLicense = license?.state === 'active';
    const hasSimilarActiveLicense = licenseByRole?.state === 'active';

    // FREE items → filtered later
    const isFree = v.price?.number == 0;

    // EXTENSION logic (old field_extension mess)
    let extension = false;
    if (v.field_extension) {


      if (!license && !licenseByRole) {
        return null;
      }

      const today = new Date();
      let extensionDate = new Date();
      if(license) {
        extensionDate = new Date(license?.expires);
      }
      if(licenseByRole) {
        extensionDate = new Date(licenseByRole?.expires);
      }
      extensionDate.setMonth(extensionDate.getMonth() + v.field_course_purchase_length);

      if(today > extensionDate) {
        return null;
      }

      extension = true;
    }

    // PREREQUISITE logic
    const prerequisiteId = v.product_id?.field_prerequisite?.id;

    const needsPrerequisiteCheck =
      !!prerequisiteId &&
      v.product_id?.field_prerequisite_required === true;

    // EXCLUDED ITEMS BASED ON ACTIVE SUBSCRIPTIONS
    const excluded = ctx.excludedCourseIds.includes(
      v.product_id?.field_course?.id
    );

    const obj: any = {
      id: v.id,
      title: v.field_variation_name,
      desc: this.htmlconvertService.convertToHtml(
        v.field_variation_description?.processed
      ),
      isTextOverflow: true,
      sku: v.sku,
      price: v.price?.formatted,
      list_price: v.list_price?.formatted,
      weight: v.field_weight ?? 0,
      month: this.getVariationMonth(v),
      type: v.type,
      type_id: v.id,
      alreadyHasLicense: hasActiveLicense,
      similarLicense: hasSimilarActiveLicense,
      extension,
      excluded,
      videostore:
        v.type.includes('video') ||
        v.type.includes('vid') ||
        v.type.includes('videostore'),
      free: isFree,
      cancellable: false,
      licenseUuid: '',
      registered_card: '',
      link: '',
      uuid: '',
      end_date: '',
      prerequisiteId: prerequisiteId,
      needsPrerequisiteCheck: needsPrerequisiteCheck
    };

    // ACTIVE LICENSE DETAILS
    if (hasActiveLicense) {
      obj.uuid = license.product_variation.product_id?.field_course?.id ?? '';
      obj.link = license.product_variation.product_id?.field_course?.title ?? '';
      obj.videostore =
        license.product_variation.product_id?.type === 'product--videostore';

      if (license.expiration_type?.target_plugin_id === 'unlimited') {
        this.fooldalService
          .getSubscriptionForVariationUuid(license.product_variation.id, license.originating_order.id)
          .subscribe((response: any) => {
            const subscription = response.data[0];
            obj.licenseUuid = subscription.id;
            obj.cancellable =
              subscription.attributes.scheduled_changes.length === 0;

            const date = new Date(subscription.attributes.next_renewal);
            obj.end_date =
              date.getFullYear() +
              '-' +
              String(date.getMonth() + 1).padStart(2, '0') +
              '-' +
              String(date.getDate()).padStart(2, '0') +
              ' ' +
              String(date.getHours()).padStart(2, '0') +
              ':' +
              String(date.getMinutes()).padStart(2, '0');

            obj.registered_card =
              subscription.attributes.field_cardmask;
          });
      } else {
        obj.end_date = license.expires?.substring(0, 10) ?? '';
      }
    }

    return obj;
  }


  // private decorateVariation(v: any, licenses: any[]) {
  //   // collect all courses excluded by active licenses
  //   const excludedCourses: string[] = [];
  //   licenses.forEach(license => {
  //     if (
  //       license.state === 'active' &&
  //       license.product_variation.product_id?.field_excludes_courses &&
  //       Array.isArray(license.product_variation.product_id.field_excludes_courses)
  //     ) {
  //       const ids = license.product_variation.product_id.field_excludes_courses.map((ex: any) => ex.id);
  //       excludedCourses.push(...ids);
  //     }
  //   });

  //   // find license for this variation
  //   const license = licenses.find(l => l.product_variation?.id === v.id);

  //   // init the object
  //   const obj: any = {
  //     id: v.id,
  //     title: v.field_variation_name,
  //     desc: this.htmlconvertService.convertToHtml(v.field_variation_description?.processed),
  //     isTextOverflow: true,
  //     sku: v.sku,
  //     price: v.price?.formatted,
  //     list_price: v.list_price?.formatted,
  //     weight: v.field_weight ?? 0,
  //     month: this.getVariationMonth(v),
  //     type: v.type,
  //     type_id: v.id,
  //     alreadyHasLicense: license?.state === 'active',
  //     excluded: excludedCourses.includes(v.field_course?.id),
  //     videostore: v.type.includes('video') || v.type.includes('vid') || v.type.includes('videostore'),
  //     free: v.price.number == 0,
  //     cancellable: false,
  //     licenseUuid: '',
  //     registered_card: '',
  //     link: '',
  //     uuid: ''
  //   };

  //   // handle license details if active
  //   if (license?.state === 'active') {
  //     obj.uuid = license.product_variation.product_id?.field_course?.id ?? '';
  //     obj.link = license.product_variation.product_id?.field_course?.title ?? '';
  //     obj.videostore = license.product_variation.product_id?.type === 'product--videostore';

  //     if (license.expiration_type?.target_plugin_id === 'unlimited') {

  //       // subscription info
  //       this.fooldalService.getSubscriptionForVariationUuid(license.product_variation.id).subscribe((response: any) => {
  //         const subscription = response.data[0];
  //         obj.licenseUuid = subscription.id;
  //         obj.cancellable = subscription.id === '4ec1059b-d204-47ce-9ce0-e25718d8308d' || subscription.attributes.scheduled_changes.length === 0;

  //         const isoString = subscription.attributes.next_renewal;
  //         const date = new Date(isoString);
  //         obj.end_date =
  //           date.getFullYear() + "-" +
  //           String(date.getMonth() + 1).padStart(2, '0') + "-" +
  //           String(date.getDate()).padStart(2, '0') + " " +
  //           String(date.getHours()).padStart(2, '0') + ":" +
  //           String(date.getMinutes()).padStart(2, '0');
  //         obj.registered_card = subscription.attributes.field_cardmask;
  //       });
  //     } else {
  //       obj.end_date = license.expires?.substring(0, 10) ?? '';
  //     }
  //   } else {
  //     // not active license, maybe just variation info
  //     obj.end_date = '';
  //   }

  //   return obj;
  // }


  private getVariationMonth(variation: any): string {
    if (variation.license_expiration?.target_plugin_id === 'unlimited') {
      return '';
    }
    const interval = variation.license_expiration?.target_plugin_configuration?.interval;
    if (!interval) return '';

    const value = interval.interval;
    const period = interval.period;

    switch (period) {
      case 'month': return value + ' hónap';
      case 'day': return value + ' nap';
      case 'year': return value + ' év';
      case 'week': return value + ' hét';
      default: return '';
    }
  }


  // ngOnInit_old() {
  //       localStorage.removeItem('teremben');
  //   this.loggedUser = this.authService.isAuthenticated();


  //   //active licenszzek
  //   this.fooldalService.enrolledCourseLicens().subscribe(s => {
  //       for (const [key, value] of Object.entries(s)) {
  //         if (key === 'data') {
  //           for (let i in value) {
  //             if (value[i].state === 'active') {
  //               this.active = true;
  //               const obj = {
  //                 title: '',
  //                 uuid: '',
  //                 videostore: false,
  //                 end_date: '',
  //                 desc: '' as SafeHtml,
  //                 isTextOverflow: true,
  //                 link: '',
  //                 cancellable: false,
  //                 licenseUuid: '',
  //                 registered_card: '',
  //                 free: false,
  //               };
  //               if (value[i].product_variation.product_id?.type === 'product--videostore') {
  //                 obj.videostore = true;
  //               }
  //               if (value[i].expiration_type.target_plugin_id === 'unlimited') {
                  
  //                 // if(value[i].product_variation.sku === 'VThosszabbítás') {
  //                   if(value[i].product_variation.price.number == 0) {
  //                     obj.free = true;
  //                   }

  //                   this.fooldalService.getSubscriptionForVariationUuid(value[i].product_variation.id).subscribe((response: any) => {
  //                     const subscription = response.data[0];
  //                     obj.licenseUuid = subscription.id;
  //                     obj.cancellable = subscription.id === '4ec1059b-d204-47ce-9ce0-e25718d8308d' || response.data[0].attributes.scheduled_changes.length === 0;
  //                     console.warn('setting end date', subscription.attributes.next_renewal);
  //                     const isoString = response.data[0].attributes.next_renewal;
  //                     const date = new Date(isoString);
  //                     obj.end_date = date.getFullYear() + "-" +
  //                                           String(date.getMonth() + 1).padStart(2, '0') + "-" +
  //                                           String(date.getDate()).padStart(2, '0') + " " +
  //                                           String(date.getHours()).padStart(2, '0') + ":" +
  //                                           String(date.getMinutes()).padStart(2, '0');
  //                     obj.registered_card = response.data[0].attributes.field_cardmask;
  //                   });
  //                 // } else {
  //                 //   obj.end_date = value[i].expires.substring(0, 10);
  //                 // }
  //               } else {
  //                 obj.end_date = value[i].expires.substring(0, 10);
  //               }
  //               // Módosított feltétel: Mindig hozzáadja az objektumot, ha az adott elem aktív
  //               if (value[i].product_variation.product_id?.field_course) {
  //                 obj.uuid = value[i].product_variation.product_id.field_course.id;
  //                 obj.title = value[i].product_variation.field_variation_name;
  //                 obj.link = value[i].product_variation.product_id.field_course.title;
  //               } else {
  //                 obj.title = value[i].product_variation.field_variation_name;
  //               }
  //               obj.desc = this.htmlconvertService.convertToHtml(value[i].product_variation.field_variation_description?.processed);

  //               if(!value[i].product_variation.status) {
  //                 continue;
  //               }
  //               this.courseDetailsExpires.push(obj);
  //             }
  //           }
  //         }
  //       }
  //   });

  //   const mainObs = this.loggedUser ? this.fooldalService.allLicensesOfCurrentUser() : of({data:[]});
  //   mainObs.subscribe((response: any) => {
  //     const licenses = response.data;
  //     const ownedCourses = licenses.map((license: any) => license.product_variation.product_id?.field_course?.id);
  //     const excludedCourses:any[] = [];
  //     licenses.forEach((license: any) => {
  //       if(license.state === 'active' && license.product_variation.product_id?.field_excludes_courses && Array.isArray(license.product_variation.product_id.field_excludes_courses)) {
  //         const ids = license.product_variation.product_id.field_excludes_courses.map((ex:any) => ex.id);
  //         excludedCourses.push(...ids);
  //       }
  //     });
  //     forkJoin([this.fooldalService.getAllProducts(), this.fooldalService.getAllVideoStoreProducts()]).pipe(
  //       map(([products, videoStoreProducts]) => [products.data, videoStoreProducts.data]),
  //       tap(([products, videoStoreProducts]) => {
  //         products.forEach((product:any) => {
  //           product.variations.forEach((variation:any) => {
  //             const license = licenses.find((license: any) => license.product_variation.product_id?.id === product.id);
  //             const hasActiveLicense = licenses.some((license: any) => license.product_variation.product_id?.id === product.id && license.state === 'active');
  //             const pastDate = new Date();
  //             pastDate.setFullYear(pastDate.getFullYear() - 3);
  //             if(!variation.field_extension || license?.product_variation?.billing_schedule?.type == 'billing-schedule') {
  //               const productPrerequisiteCourseId = product.field_prerequisite?.id;
  //               if(productPrerequisiteCourseId && !license && ownedCourses.includes(productPrerequisiteCourseId) && !excludedCourses.includes(product.field_course.id)) {
  //                 this.processProductVariation(variation);
  //               }
  //               else if(!productPrerequisiteCourseId && (!license || (license.state === 'expired' && new Date(license.expires) < pastDate)) && !excludedCourses.includes(product.field_course.id)){
  //                 //this.processProductVariation(variation);
  //               }

  //               if(!productPrerequisiteCourseId) {
  //                 this.processSecondaryProductVariation(variation, hasActiveLicense, excludedCourses.includes(product.field_course.id));
  //               }
  //             } else {
  //               const productPrerequisiteCourseId = product.field_prerequisite?.id;
  //               if(productPrerequisiteCourseId && ownedCourses.includes(productPrerequisiteCourseId) && !excludedCourses.includes(product.field_course.id)) {
  //                 if(product.field_prerequisite_required) {
  //                   this.sharedService.spinner$.next(true);
  //                   this.fooldalService.enrolledUserOutline(product.field_course.meta.drupal_internal__target_id).subscribe((response: any) => {

  //                     if(Object.values(response.outline).every((item: any) => item.fulfillment.complete[0] && item.fulfillment.complete[0].value)) {
  //                       this.processProductVariation(variation);
  //                     }
  //                     this.sharedService.spinner$.next(false);
  //                   });
  //                 } else {
  //                   this.processProductVariation(variation);
  //                 }

  //               }
  //               else if(!productPrerequisiteCourseId && license) {

  //                 if(license.state === 'active' ||  (license.state === 'expired' && new Date(license.expires) > pastDate)) {
  //                   this.processProductVariation(variation);
  //                 }
  //               }
  //             }
  //           });
  //         });

  //         videoStoreProducts.forEach((product:any) => {
  //           product.variations.forEach((variation:any) => {
  //             const license = licenses.find((license: any) => license.product_variation.product_id?.id === product.id);
  //             const hasActiveLicense = licenses.some((license: any) => license.product_variation.product_id?.id === product.id && license.state === 'active');
  //             const sameVariation = licenses.find((license:any) => license.product_variation.id === variation.id);
  //             const pastDate = new Date(new Date().getDate() - 10);
  //             if(!variation.field_extension || license?.product_variation?.billing_schedule?.type == 'billing-schedule') {
  //               if(!license || (license.state === 'expired' && new Date(license.expires) < pastDate)) {
  //                 this.processVideoStoreProductVariation(variation, hasActiveLicense);
  //               }
  //               else {
  //                 this.processSecondaryVideoStoreProductVariation(variation, hasActiveLicense);
  //               }
  //             } else  {
  //               if(license && !sameVariation) {

  //                 if(license.state === 'active' ||  (license.state === 'expired' && new Date(license.expires) > pastDate)) {
  //                   this.processVideoStoreProductVariation(variation);
  //                 }
  //               }
  //             }
  //           });
  //         });
  //         this.sharedService.spinner$.next(false);
  //       })
  //     ).subscribe();

  //   });


  //   //kurzusok kiirása, amikor nincs bejelentkezve
  //   this.fooldalService.getCourses().subscribe(c => {
  //     for (const [key, value] of Object.entries(c)) {
  //       if (key === 'courses') {
  //         for (let i in value) {
  //           const objCourse = {
  //             title: value[i].title[0].value,
  //             uuidCourse: value[i].uuid[0].value
  //           };
  //           this.course.push(objCourse);

  //         }
  //       }
  //     }
  //   });

  //   this.fooldalService.getPreviews().subscribe((previewResponse:any) => {
  //     previewResponse.data.forEach((preview: any) => {
  //       const variations = preview.variations.map((variation: any) => {
  //         return {
  //           link: preview.title,
  //           title: variation.field_variation_name,
  //           desc: this.htmlconvertService.convertToHtml(variation.field_variation_description?.processed),
  //           price: variation.price.formatted,
  //         }
  //       });
  //       this.coursePreviews.push(...variations);
  //     });
  //   });
  // }

  secondaryProductsForLicens: any[] = [];
  private processSecondaryProductVariation(variation: any, alreadyHasLicense?: boolean, excluded?: boolean) {
    var productsObj = {
      title: '',
      sku: '',
      desc: '' as SafeHtml,isTextOverflow: true,
      list_price: '',
      price: '',
      month: '',
      type: '',
      type_id: '',
      alreadyHasLicense,
      excluded
    }
    productsObj.type = variation.type;
    productsObj.type_id = variation.id;
    productsObj.sku = variation.sku;
    productsObj.desc = this.htmlconvertService.convertToHtml(variation.field_variation_description?.processed);
    if (variation.list_price !== null) {
      productsObj.list_price = variation.list_price.formatted;
    }
    productsObj.price = variation.price.formatted;

    const regex = /(.+?) - (\d+ .*)/;
    const founded = variation.title.match(regex);
    if (founded) {
      const cutTitle = founded[1].trim();
      const cutMonth = founded[2].trim();
      productsObj.title = cutTitle;
      productsObj.month = cutMonth;
    } else {
      if(variation.license_expiration.target_plugin_id !== 'unlimited') {
        const value = variation.license_expiration.target_plugin_configuration.interval.interval;
        const periodName = variation.license_expiration.target_plugin_configuration.interval.period;
        if(periodName === 'month') {
          productsObj.month = value + ' hónap';
        }
        if(periodName === 'day') {
          productsObj.month = value + ' nap';
        }
        if(periodName === 'year') {
          productsObj.month = value + ' év';
        }
        if(periodName === 'week') {
          productsObj.month = value + ' hét';
        }
      }
    }
    productsObj.title = variation.field_variation_name;
    if(!variation.status) {
      return;
    }
    this.secondaryProductsForLicens.push(productsObj);
  }

  private processProductVariation(variation: any) {
    var productsObj = {
      title: '',
      sku: '',
      desc: '' as SafeHtml,isTextOverflow: true,
      list_price: '',
      price: '',
      month: '',
      type: '',
      type_id: '',

    }
    productsObj.type = variation.type;
    productsObj.type_id = variation.id;
    productsObj.sku = variation.sku;
    productsObj.desc = this.htmlconvertService.convertToHtml(variation.field_variation_description?.processed);
    if (variation.list_price !== null) {
      productsObj.list_price = variation.list_price.formatted;
    }
    productsObj.price = variation.price.formatted;

    const regex = /(.+?) - (\d+ .*)/;
    const founded = variation.title.match(regex);
    if (founded) {
      const cutTitle = founded[1].trim();
      const cutMonth = founded[2].trim();
      productsObj.title = cutTitle;
      productsObj.month = cutMonth;
    } else {
      if(variation.license_expiration.target_plugin_id !== 'unlimited') {
        const value = variation.license_expiration.target_plugin_configuration.interval.interval;
        const periodName = variation.license_expiration.target_plugin_configuration.interval.period;
        if(periodName === 'month') {
          productsObj.month = value + ' hónap';
        }
        if(periodName === 'day') {
          productsObj.month = value + ' nap';
        }
        if(periodName === 'year') {
          productsObj.month = value + ' év';
        }
        if(periodName === 'week') {
          productsObj.month = value + ' hét';
        }
      }
    }
    productsObj.title = variation.field_variation_name;
    if(!variation.status) {
      return;
    }
    this.productsForLicens.push(productsObj);
  }

  secondaryProductsVidForLicens: any[] = [];
  private processSecondaryVideoStoreProductVariation(variation: any, alreadyHasLicense?: boolean) {
    if(variation.sku === 'VTFREEF' || variation.sku === 'VTFREE') {
      return;
    }
    if(variation.price.number == 0) {
      return;
    }
    var productVidObj = {
      title: '',
      sku: '',
      desc: '' as SafeHtml,isTextOverflow: true,
      list_price: '',
      price: '',
      month: '',
      type: '',
      type_id: '',
      alreadyHasLicense: false
    }
    productVidObj.type = variation.type;
    productVidObj.alreadyHasLicense = !!alreadyHasLicense;
    productVidObj.type_id = variation.id;
    productVidObj.sku = variation.sku;
    productVidObj.desc = this.htmlconvertService.convertToHtml(variation.field_variation_description?.processed);
    if (variation.list_price !== null) {
      productVidObj.list_price = variation.list_price.formatted;
    }
    const split = variation.price.formatted.split(',');
    const priceToConvert = split[0].replace(/\s/g, '');
    const price = Number(variation.price.number);
    const per10 = price * this.percentage;
    const pricePer10minus = price - per10;
    const formattedString = pricePer10minus.toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, " ").replace('.', ',');
    productVidObj.price = formattedString + " Ft";
    const regex = /(.+?) - (\d+ .*)/;
    const founded = variation.title.match(regex);
    if (founded) {
      const cutTitle = founded[1].trim();
      const cutMonth = founded[2].trim();

      productVidObj.month = cutMonth;
    } else {
      if(variation.license_expiration.target_plugin_id !== 'unlimited') {
        const value = variation.license_expiration.target_plugin_configuration.interval.interval;
        const periodName = variation.license_expiration.target_plugin_configuration.interval.period;
        if(periodName === 'month') {
          productVidObj.month = value + ' hónap';
        }
        if(periodName === 'day') {
          productVidObj.month = value + ' nap';
        }
        if(periodName === 'year') {
          productVidObj.month = value + ' év';
        }
        if(periodName === 'week') {
          productVidObj.month = value + ' hét';
        }
      }
    }
    productVidObj.title = variation.field_variation_name;
    if(!variation.status) {
      return;
    }
    this.secondaryProductsVidForLicens.push(productVidObj);
  };

  private processVideoStoreProductVariation(variation: any, alreadyHasLicense?: boolean) {
    if(variation.sku === 'VTFREEF' || variation.sku === 'VTFREE') {
      return;
    }
    if(variation.price.number == 0) {
      return;
    }
    var productVidObj = {
      title: '',
      sku: '',
      desc: '' as SafeHtml,isTextOverflow: true,
      list_price: '',
      price: '',
      month: '',
      type: '',
      type_id: '',
      alreadyHasLicense: false
    }
    productVidObj.type = variation.type;
    productVidObj.alreadyHasLicense = !!alreadyHasLicense;
    productVidObj.type_id = variation.id;
    productVidObj.sku = variation.sku;
    productVidObj.desc = this.htmlconvertService.convertToHtml(variation.field_variation_description?.processed);
    if (variation.list_price !== null) {
      productVidObj.list_price = variation.list_price.formatted;
    }
    const split = variation.price.formatted.split(',');
    const priceToConvert = split[0].replace(/\s/g, '');
    const price = Number(variation.price.number);
    const per10 = price * this.percentage;
    const pricePer10minus = price - per10;
    const formattedString = pricePer10minus.toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, " ").replace('.', ',');
    productVidObj.price = formattedString + " Ft";
    const regex = /(.+?) - (\d+ .*)/;
    const founded = variation.title.match(regex);
    if (founded) {
      const cutTitle = founded[1].trim();
      const cutMonth = founded[2].trim();

      productVidObj.month = cutMonth;
    } else {
      if(variation.license_expiration.target_plugin_id !== 'unlimited') {
        const value = variation.license_expiration.target_plugin_configuration.interval.interval;
        const periodName = variation.license_expiration.target_plugin_configuration.interval.period;
        if(periodName === 'month') {
          productVidObj.month = value + ' hónap';
        }
        if(periodName === 'day') {
          productVidObj.month = value + ' nap';
        }
        if(periodName === 'year') {
          productVidObj.month = value + ' év';
        }
        if(periodName === 'week') {
          productVidObj.month = value + ' hét';
        }
      }
    }
    productVidObj.title = variation.field_variation_name;
    if(!variation.status) {
      return;
    }
    this.productsVidForLicens.push(productVidObj);
  };

  prev(preview: any) {
    this.router.navigate(['/kurzusok/' + preview.link]);
  }



  ngOnDestroy() {
    if (this.loggedInUserSubscription) {
      this.loggedInUserSubscription.unsubscribe();
    }
  }

  get isAdmin(): boolean {
    return this.authService.isAdmin();
  }

  isTextOverflowing(lesson: any, measureContainer?: HTMLParagraphElement) {
    if(measureContainer) {
      return measureContainer.scrollHeight > 120;
    }
    const textContainer = document.createElement('div');
    textContainer.innerHTML = lesson.desc;
    document.body.appendChild(textContainer);
    const isOverflowing = textContainer.scrollHeight > 90;
    lesson.scrollHeight = textContainer.scrollHeight;
    document.body.removeChild(textContainer);
    return isOverflowing;
  }


  toggleTextOverflow(lesson: any) {
    lesson.isTextOverflow = !lesson.isTextOverflow;
  }

  openModal(platform: string, data?: any) {
    this.modalData = data;
    const modal = document.getElementById('exampleModal');
    if (modal) {
      modal.style.display = 'block';
      modal.classList.add('show');
    }
    this.showModal = true;
    this.platform = platform;
    this.renderer.addClass(document.body, 'no-scroll');

    // Az adott platformnak megfelelő tartalom beállítása
    this.modalTitle = '';
    this.modalContent = '';
    this.modalCancelTitle = 'Bezárás';
    this.modalActionTitle = '';

    switch (platform) {
      case 'cancel-recurring-videostore':
        this.modalTitle = 'Biztos, hogy lemondod a Videótár előfizetésed?';
        this.modalContent = 'Ha igennel válaszolsz, a következő havi terhelés elmarad, már csak addig tudod a Videótárad használni.';
        this.modalActionTitle = 'Igen';
        this.modalCancelTitle = 'Nem';
        break;
      case 'cancel-recurring':
        this.modalTitle = 'Biztos, hogy lemondod a kurzus előfizetésed?';
        this.modalContent = 'Ha igennel válaszolsz, a következő havi terhelés elmarad, már csak addig tudod a kurzusodat használni.<br/>Amennyiben az előfizetésedhez járt ingyenes videótár, akkor az is le fog járni ugyanabban az időben.';
        this.modalActionTitle = 'Igen';
        this.modalCancelTitle = 'Nem';
        break;
    }

    // A popup tartalom és cím beállítása
    const modalTitleElement = document.querySelector('.modal-title');
    const modalBody = document.querySelector('.modal-body');
    if (modalTitleElement && modalBody) {
      modalTitleElement.innerHTML = this.modalTitle;
      modalBody.innerHTML = this.modalContent;
    }
  }

  closeModal() {
    const modal = document.getElementById('exampleModal');
    if (modal) {
      modal.style.display = 'none';
      modal.classList.remove('show');
    }
    this.showModal = false;
    this.renderer.removeClass(document.body, 'no-scroll');
  }

  doModalAction() {
    switch (this.platform) {
      case 'cancel-recurring-videostore':
        this.cancel(this.modalData);
        break;
      case 'cancel-recurring':
        this.cancel(this.modalData);
        break;
    }

  }
}
